import s from './ModalProjectCard.module.scss';
import { BiLinkExternal } from 'react-icons/bi';
import Modal from '../../../components/Modal/Modal';
import Button from '../../../components/UIElements/Button/Button';
import { useParams } from 'react-router-dom';
import { useModal } from '../../../hooks/modalHook';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { dataRef } from '../../../data/firebaseConfig'
import { useEffect, useState } from 'react';
import modelData from './modelData';

const ModalProjectCard = () => {
  const [projects ,setProjects]=useState([])
  const { id } = useParams();
  const { isVisible, toggleModal } = useModal();

  let [img,setImg]=useState("")
  let [title,settitel]=useState("")
  let [tech,setTech]=useState([]);
  let [site,setSite]=useState("")

  useEffect(() => {
    toggleModal();
  },[]);

  useEffect(() => {
    dataRef.ref().child(`data/${id-1}`).on('value',data=>{
        const getData=Object.values(data.val());
        setProjects(getData)
      setImg(getData[2].src)
      settitel(getData[5])
      setTech(getData[4])
      setSite(getData[3].site)
    })
  },[]);
  


  
 
  return (
    <Modal show={isVisible} onClose={toggleModal}>
      <div className={s.cardWrapper}>
        <LazyLoadImage
          alt="project-img"
          src={img}             
          effect="blur"
          width="100%"
          wrapperClassName={s.image}
          // placeholderSrc={projects[2].placeholderSrc}
        />
        <div className={s.cardBody}>
          <h3 className={s.title}>{title}</h3>

          <div className={s.technologies}>
            {tech.map((tech, index) => (
              <span key={index}>{tech}</span>
            ))}
          </div>
        </div>

        <div className={s.cardFooter}>
          <Button
            style={{ width: '12rem' }}
            className="primary"
            href={site}
            target="_blank"
          >
            <BiLinkExternal /> &nbsp; View project
          </Button>

          {/* {!!projects.links.repo && (
            <Button
              style={{ width: '12rem' }}
              className="primary"
              href={"link"}
              target="_blank"
            >
              <BiLinkExternal /> &nbsp; Know more
            </Button>
          )} */}
        </div>
      </div>
    </Modal>
  );
};

export default ModalProjectCard;
